export default __webpack_public_path__ + "static/media/hospitalityjobs.a8312aba.jpg";